import fileDownload from "js-file-download";
import React, { Component } from "react";
import { Link } from "react-router";

export default class RowItemCanCuCuocThanhTraView extends Component {
  render() {
    const { tenVanBan, coQuanBanHanhInfo, loaiVanBanInfo, linhVucVanBanInfo, documentMetaDataInfo } =
      this.props.item || [];
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{tenVanBan || ""}</td>
        <td>{coQuanBanHanhInfo.ten || ""}</td>
        <td>{loaiVanBanInfo.ten || ""}</td>
        <td>{linhVucVanBanInfo.ten || ""}</td>
        <td>
          <Link
            onClick={fileDownload.bind(this, documentMetaDataInfo.documentId, documentMetaDataInfo.ten)}
            className="txt-underline txt-blue"
          >
            {documentMetaDataInfo.ten || ""}
          </Link>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemCanCuCuocThanhTraView.jsx